import React, { useEffect, useState } from 'react';
import VairantTables from './VairantTables';
import "../../index.css";
import styles from "./Variant.module.css";
import { Tag, Select, Input } from 'antd';
import { PlusOutlined, CheckOutlined } from '@ant-design/icons';
import { toast } from 'react-toastify';

export default function Variants({
    submitFun,
    id,
    productIdVariantsData,
    hasVariants,
    product,
    upDateVariantsHandler,
    productTypeNmae,
    manDatoryAttr,
    getVariantsData,
    handleOpen,
    handleClose,
    deletHandlerWhileCreate
}: any) {

    const [variatType, setVariantType] = useState<string>("colour");
    const [searchValue, setSearchValue] = useState<string>("");
    const [customAttrName, setCustomAttrName] = useState<string>("");
    const [optionValues, setOptionValues] = useState<number[]>([0]);
    const [inputValues, setInputValues] = useState<string[]>([""]);
    const [inlineNewValues, setInlineNewValues] = useState<{ [key: string]: string }>({});

    const [dataSet, setdataSet] = useState<any>({
        colour: [],
        size: [],
        model: [],
        storage: [],
        RAM: [],
        material: [],
        fabric: [],
        pattern: [],
        style: [],
        brand: [],
        screen_size: [],
        battery_capacity: [],
        processor: [],
        os_type: [],
        pack_of: [],
        variant: [],
        flavour: [],
        fragrance: [],
        finish: [],
        weight: [],
        volume: [],
        gender: [],
    });

    const [tableData, settableData] = useState<any[]>([]);

    // Base comprehensive list of attribute types
    const baseAttributes = [
        { type: "colour", label: "Colour" },
        { type: "size", label: "Size" },
        { type: "model", label: "Model" },
        { type: "storage", label: "Storage" },
        { type: "RAM", label: "RAM" },
        { type: "brand", label: "Brand" },
        { type: "material", label: "Material" },
        { type: "fabric", label: "Fabric" },
        { type: "pattern", label: "Pattern" },
        { type: "style", label: "Style" },
        { type: "fit", label: "Fit" },
        { type: "sleeve", label: "Sleeve" },
        { type: "collar", label: "Collar" },
        { type: "occasion", label: "Occasion" },
        { type: "pack_of", label: "Pack of" },
        { type: "gender", label: "Gender" },
        { type: "screen_size", label: "Screen Size" },
        { type: "processor", label: "Processor" },
        { type: "os_type", label: "Operating System (OS)" },
        { type: "battery_capacity", label: "Battery Capacity" },
        { type: "resolution", label: "Resolution" },
        { type: "connectivity", label: "Connectivity" },
        { type: "variant", label: "Variant" },
        { type: "flavour", label: "Flavour" },
        { type: "fragrance", label: "Fragrance" },
        { type: "finish", label: "Finish" },
        { type: "weight", label: "Weight" },
        { type: "volume", label: "Volume / Capacity" },
        { type: "custom", label: "+ Custom Attribute" },
    ];

    // Combine base attributes with category specific mandatory attributes
    const dynamicMandatory = (manDatoryAttr || [])
        .map((item: any) => {
            const name = item?.mandatory_attribute;
            if (!name) return null;
            return {
                type: String(name).toLowerCase().replace(/\s+/g, '_'),
                label: String(name).replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase()),
            };
        })
        .filter(Boolean);

    const standardAttributes = Array.from(
        new Map(
            [...baseAttributes, ...dynamicMandatory].map((item: any) => [item.type, item])
        ).values()
    );

    // Normalize incoming variants data from API on edit mode
    useEffect(() => {
        if (productIdVariantsData && productIdVariantsData.length > 0) {
            const normalized = productIdVariantsData.map((item: any) => {
                let variantGroup = Array.isArray(item.variant_group) ? [...item.variant_group] : [];
                if (variantGroup.length === 0) {
                    if (Array.isArray(item.attributes) && item.attributes.length > 0) {
                        variantGroup = item.attributes.map((a: any) => ({
                            variant_name: a.attribute_name || a.name,
                            variant_value: a.attribute_value || a.value,
                        }));
                    } else if (item.features) {
                        let feat = item.features;
                        if (typeof feat === 'string') {
                            try { feat = JSON.parse(feat); } catch (e) { feat = {}; }
                        }
                        if (typeof feat === 'object' && feat !== null) {
                            if (Array.isArray(feat)) {
                                feat.forEach((f: any) => {
                                    if (typeof f === 'object' && f !== null) {
                                        Object.entries(f).forEach(([k, v]) => {
                                            variantGroup.push({ variant_name: k, variant_value: v });
                                        });
                                    }
                                });
                            } else {
                                Object.entries(feat).forEach(([k, v]) => {
                                    variantGroup.push({ variant_name: k, variant_value: v });
                                });
                            }
                        }
                    }
                }

                const mrpVal = item.mrp || item.maximum_price || item.base_price || (Array.isArray(item.price) ? item.price[0]?.base_price : item.price?.base_price) || item.price?.mrp || product?.maximum_price || "";
                const sellingPriceVal = item.selling_price || item.current_price || (Array.isArray(item.price) ? item.price[0]?.current_price : item.price?.current_price) || item.price?.selling_price || product?.selling_price || "";
                const minPriceVal = item.min_price || item.minimum_price || (Array.isArray(item.price) ? item.price[0]?.min_price : item.price?.min_price) || sellingPriceVal || "";
                const maxPriceVal = item.max_price || item.maximum_price || (Array.isArray(item.price) ? item.price[0]?.max_price : item.price?.max_price) || mrpVal || "";
                const qtyVal = item.quantity ?? item.qty ?? (Array.isArray(item.inventories) ? item.inventories[0]?.quantity : item.inventories?.quantity) ?? item.available_qty ?? product?.quantity ?? "";
                const skuVal = item.sku || product?.sku || "";
                const gtinVal = item.gtin || product?.gtin || "";
                const hsnVal = item.hsn || item.hsn_code || product?.hsn || "";
                const weightVal = item.weight || item.weights || product?.weights || product?.weight || "0.25";
                const uomVal = item.uom || product?.uom || "piece";

                return {
                    ...item,
                    variant_group: variantGroup,
                    sku: skuVal,
                    gtin: gtinVal,
                    hsn: hsnVal,
                    mrp: mrpVal,
                    selling_price: sellingPriceVal,
                    base_price: mrpVal,
                    current_price: sellingPriceVal,
                    min_price: minPriceVal,
                    max_price: maxPriceVal,
                    price_type: item?.price?.price_type || "fixed",
                    tax_included_price: sellingPriceVal,
                    quantity: qtyVal,
                    available_qty: qtyVal,
                    weight: weightVal,
                    weights: weightVal,
                    uom: uomVal,
                    status: item?.status !== undefined ? Boolean(item.status) : true,
                    image: item?.image ? (typeof item?.image === "string" ? item?.image?.split(",") : (Array.isArray(item.image) ? item.image : [item.image])) : [],
                };
            });

            settableData(normalized);

            const variantValues: any = {};
            normalized.forEach((prodItem: any) => {
                if (Array.isArray(prodItem.variant_group)) {
                    prodItem.variant_group.forEach((variant: any) => {
                        const vName = variant.variant_name || variant.name;
                        const vVal = variant.variant_value || variant.value;
                        if (vName && vVal !== undefined && vVal !== null && String(vVal).trim() !== "") {
                            if (!variantValues[vName]) {
                                variantValues[vName] = [];
                            }
                            if (!variantValues[vName].includes(String(vVal))) {
                                variantValues[vName].push(String(vVal));
                            }
                        }
                    });
                }
            });

            setdataSet((prev: any) => ({ ...prev, ...variantValues }));
        }
    }, [productIdVariantsData]);

    // Handle Option Value Input changes
    const handleOptionInputChange = (val: string, index: number) => {
        const updated = [...inputValues];
        updated[index] = val;
        setInputValues(updated);
    };

    // Add more input line for the selected attribute
    const handleAddMoreInput = () => {
        setOptionValues((prev) => [...prev, prev.length]);
        setInputValues((prev) => [...prev, ""]);
    };

    // Submit / Done for the selected attribute type
    const handleDoneAttribute = () => {
        const activeKey = variatType === "custom" ? customAttrName.trim() : variatType;
        if (!activeKey) {
            toast.error("Please specify an attribute name!");
            return;
        }

        const validValues = inputValues.map((v) => v.trim()).filter((v) => v.length > 0);
        if (validValues.length === 0) {
            toast.error("Please enter at least one attribute value!");
            return;
        }

        const existing = dataSet[activeKey] || [];
        const combined = Array.from(new Set([...existing, ...validValues]));

        const newDataSet = { ...dataSet, [activeKey]: combined };
        setdataSet(newDataSet);
        setOptionValues([0]);
        setInputValues([""]);
        if (variatType === "custom") {
            setCustomAttrName("");
        }

        generateOrAppendCombinations(newDataSet);
        toast.success(`Added ${validValues.length} value(s) to ${activeKey}`);
    };

    // Add single value from an individual attribute card
    const handleAddSingleValueToAttr = (attrKey: string) => {
        const val = inlineNewValues[attrKey]?.trim();
        if (!val) {
            toast.error("Please enter a value!");
            return;
        }

        const existing = dataSet[attrKey] || [];
        if (existing.includes(val)) {
            toast.warning(`Value "${val}" already exists in ${attrKey}`);
            return;
        }

        const newDataSet = { ...dataSet, [attrKey]: [...existing, val] };
        setdataSet(newDataSet);
        setInlineNewValues((prev) => ({ ...prev, [attrKey]: "" }));
        generateOrAppendCombinations(newDataSet);
    };

    // Remove single tag value
    const handleRemoveAttributeValue = (attrKey: string, valToRemove: string) => {
        const existing = dataSet[attrKey] || [];
        const updated = existing.filter((v: string) => v !== valToRemove);
        const newDataSet = { ...dataSet, [attrKey]: updated };
        if (updated.length === 0) {
            delete newDataSet[attrKey];
        }
        setdataSet(newDataSet);
    };

    // Generate combinations
    const generateOrAppendCombinations = (currentDataSet: any) => {
        const keys = Object.keys(currentDataSet).filter((k) => currentDataSet[k] && currentDataSet[k].length > 0);
        if (keys.length === 0) return;

        const newCombinations: any[] = [];
        const recurse = (current: any, index: number) => {
            if (index === keys.length) {
                newCombinations.push({ ...current });
                return;
            }
            const key = keys[index];
            currentDataSet[key].forEach((val: any) => {
                current[key] = val;
                recurse({ ...current }, index + 1);
            });
        };
        recurse({}, 0);

        settableData((prev) => {
            const existingRows = [...prev];
            const updatedRows: any[] = [];

            newCombinations.forEach((comb, idx) => {
                const combGroup = Object.entries(comb).map(([k, v]) => ({
                    variant_name: k,
                    variant_value: String(v),
                }));

                const foundExisting = existingRows.find((row) => {
                    const rowGroup = row.variant_group || [];
                    return combGroup.every((cg) =>
                        rowGroup.some((rg: any) => (rg.variant_name || rg.name) === cg.variant_name && String(rg.variant_value || rg.value) === cg.variant_value)
                    );
                });

                if (foundExisting) {
                    updatedRows.push(foundExisting);
                } else {
                    const fallbackRow = existingRows[idx] || {};
                    updatedRows.push({
                        ...fallbackRow,
                        variant_group: combGroup,
                        sku: fallbackRow.sku || `${product?.sku || "SKU"}-${Object.values(comb).join("-")}`,
                        gtin: fallbackRow.gtin || product?.gtin || "",
                        hsn: fallbackRow.hsn || product?.hsn || "",
                        mrp: fallbackRow.mrp || fallbackRow.base_price || product?.maximum_price || "",
                        selling_price: fallbackRow.selling_price || fallbackRow.current_price || product?.selling_price || "",
                        base_price: fallbackRow.mrp || fallbackRow.base_price || product?.maximum_price || "",
                        current_price: fallbackRow.selling_price || fallbackRow.current_price || product?.selling_price || "",
                        quantity: fallbackRow.quantity || product?.quantity || 10,
                        uom: fallbackRow.uom || product?.uom || "piece",
                        weight: fallbackRow.weight || product?.weights || "0.25",
                        status: true,
                        image: fallbackRow.image || (product?.image ? (Array.isArray(product.image) ? product.image : [product.image]) : []),
                    });
                }
            });

            return updatedRows.length > 0 ? updatedRows : existingRows;
        });
    };

    // Add manual custom variant row
    const handleAddManualVariantRow = () => {
        const newRow = {
            id: `temp_${Date.now()}`,
            variant_group: [
                { variant_name: "variant", variant_value: `Option ${tableData.length + 1}` }
            ],
            sku: `${product?.sku || "SKU"}-${tableData.length + 1}`,
            gtin: product?.gtin || "",
            hsn: product?.hsn || "",
            mrp: product?.maximum_price || "",
            selling_price: product?.selling_price || "",
            base_price: product?.maximum_price || "",
            current_price: product?.selling_price || "",
            quantity: 10,
            uom: "piece",
            weight: product?.weights || "0.25",
            status: true,
            image: product?.image ? (Array.isArray(product.image) ? product.image : [product.image]) : [],
        };
        settableData((prev) => [...prev, newRow]);
        toast.info("Added new custom variant row to table below");
    };

    const activeAttributeKeys = Object.keys(dataSet).filter((k) => dataSet[k] && dataSet[k].length > 0);

    return (
        <div style={{ background: "#FFFFFF", padding: "16px", borderRadius: "12px" }}>
            {/* Top Section: Active Attribute Blocks */}
            {activeAttributeKeys.length > 0 && (
                <div style={{ marginBottom: "20px" }}>
                    <h6 style={{ fontWeight: 700, color: "#1E293B", fontSize: "14px", marginBottom: "12px" }}>
                        Active Attribute Types ({activeAttributeKeys.length})
                    </h6>
                    <div className="row">
                        {activeAttributeKeys.map((attrKey) => (
                            <div className="col-md-6 col-lg-4 mb-3" key={attrKey}>
                                <div
                                    style={{
                                        backgroundColor: "#F8FAFC",
                                        border: "1px solid #E2E8F0",
                                        borderRadius: "10px",
                                        padding: "12px 14px",
                                        height: "100%",
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "space-between"
                                    }}
                                >
                                    <div>
                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                            <span style={{ fontWeight: 700, textTransform: "capitalize", color: "#0F172A", fontSize: "13px" }}>
                                                {attrKey}
                                            </span>
                                            <span className="badge badge-light border" style={{ fontSize: "10px" }}>
                                                {dataSet[attrKey].length} value(s)
                                            </span>
                                        </div>

                                        {/* Values Badges */}
                                        <div className="d-flex flex-wrap mb-2" style={{ gap: "5px", minHeight: "28px" }}>
                                            {dataSet[attrKey].map((val: string, idx: number) => (
                                                <Tag
                                                    key={idx}
                                                    closable
                                                    onClose={() => handleRemoveAttributeValue(attrKey, val)}
                                                    color="blue"
                                                    style={{ margin: 0, borderRadius: "6px", fontWeight: 600, fontSize: "12px" }}
                                                >
                                                    {val}
                                                </Tag>
                                            ))}
                                        </div>
                                    </div>

                                    {/* Inline Add Value Input */}
                                    <div className="d-flex mt-2" style={{ gap: "6px" }}>
                                        <input
                                            type="text"
                                            className="form-control form-control-sm"
                                            style={{ fontSize: "12px", borderRadius: "6px" }}
                                            placeholder={`Add new ${attrKey}`}
                                            value={inlineNewValues[attrKey] || ""}
                                            onChange={(e) => setInlineNewValues({ ...inlineNewValues, [attrKey]: e.target.value })}
                                            onKeyPress={(e) => { if (e.key === 'Enter') handleAddSingleValueToAttr(attrKey); }}
                                        />
                                        <button
                                            type="button"
                                            className="btn btn-sm btn-primary"
                                            style={{ borderRadius: "6px", fontSize: "12px", fontWeight: 600, padding: "0 10px", whiteSpace: "nowrap" }}
                                            onClick={() => handleAddSingleValueToAttr(attrKey)}
                                        >
                                            + Add
                                        </button>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            )}

            {/* Add Attribute Options Box */}
            <div
                style={{
                    backgroundColor: "#F8FAFC",
                    border: "1px solid #E2E8F0",
                    borderRadius: "12px",
                    padding: "16px 20px",
                    marginBottom: "20px"
                }}
            >


                <div className="row">
                    {/* Option Name Dropdown */}
                    <div className="col-md-4 mb-2">
                        <label style={{ fontSize: "12px", fontWeight: 600, color: "#475569", marginBottom: "4px", display: "block" }}>
                            Option Name
                        </label>
                        <Select
                            showSearch
                            placeholder="Select or search Option Name"
                            searchValue={searchValue}
                            onSearch={(text) => setSearchValue(text)}
                            value={variatType === "custom" ? (customAttrName || searchValue || "custom") : variatType}
                            onChange={(val) => {
                                const found = standardAttributes.find((a) => a.type === val || a.label === val);
                                if (found) {
                                    if (val === "custom") {
                                        setVariantType("custom");
                                        setCustomAttrName("");
                                    } else {
                                        setVariantType(val);
                                        setCustomAttrName("");
                                    }
                                } else {
                                    setVariantType("custom");
                                    setCustomAttrName(val);
                                }
                            }}
                            onBlur={() => {
                                if (searchValue.trim()) {
                                    const found = standardAttributes.find(
                                        (a) => a.type.toLowerCase() === searchValue.trim().toLowerCase() ||
                                            a.label.toLowerCase() === searchValue.trim().toLowerCase()
                                    );
                                    if (found) {
                                        setVariantType(found.type);
                                    } else {
                                        setVariantType("custom");
                                        setCustomAttrName(searchValue.trim());
                                    }
                                }
                            }}
                            style={{ width: "100%" }}
                            size="middle"
                        >
                            {searchValue.trim() &&
                                !standardAttributes.some(
                                    (a) => a.type.toLowerCase() === searchValue.trim().toLowerCase() ||
                                        a.label.toLowerCase() === searchValue.trim().toLowerCase()
                                ) && (
                                    <Select.Option key="custom_dynamic" value={searchValue.trim()}>
                                        + Create "{searchValue.trim()}"
                                    </Select.Option>
                                )}
                            {standardAttributes.map((attr) => (
                                <Select.Option key={attr.type} value={attr.type}>
                                    {attr.label}
                                </Select.Option>
                            ))}
                        </Select>

                        {(variatType === "custom" || customAttrName) && (
                            <div className="mt-2">
                                <label style={{ fontSize: "12px", fontWeight: 600, color: "#475569", marginBottom: "4px", display: "block" }}>
                                    Custom Attribute Name
                                </label>
                                <Input
                                    placeholder="e.g. Finish, Processor, Capacity"
                                    value={customAttrName}
                                    onChange={(e) => setCustomAttrName(e.target.value)}
                                    size="middle"
                                />
                            </div>
                        )}
                    </div>

                    {/* Option Values List with + Add More and Done buttons */}
                    <div className="col-md-8 mb-2">
                        <label style={{ fontSize: "12px", fontWeight: 600, color: "#475569", marginBottom: "4px", display: "block" }}>
                            Option Values
                        </label>

                        {optionValues.map((_, index) => (
                            <div key={index} className="d-flex align-items-center mb-2" style={{ gap: "8px" }}>
                                <input
                                    type="text"
                                    className="form-control"
                                    style={{ fontSize: "13px", borderRadius: "8px" }}
                                    placeholder={`Enter ${variatType === "custom" ? (customAttrName || "value") : variatType} (e.g. ${variatType === "storage" ? "128GB" : variatType === "size" ? "M, L, XL" : "Red, Blue"})`}
                                    value={inputValues[index] || ""}
                                    onChange={(e) => handleOptionInputChange(e.target.value, index)}
                                    onKeyPress={(e) => { if (e.key === 'Enter') handleDoneAttribute(); }}
                                />

                                {optionValues.length > 1 && (
                                    <button
                                        type="button"
                                        className="btn btn-sm btn-light border text-danger"
                                        style={{ borderRadius: "8px", padding: "6px 10px", fontWeight: 700 }}
                                        title="Remove value input"
                                        onClick={() => {
                                            const updatedOpt = [...optionValues];
                                            const updatedInp = [...inputValues];
                                            updatedOpt.splice(index, 1);
                                            updatedInp.splice(index, 1);
                                            setOptionValues(updatedOpt);
                                            setInputValues(updatedInp);
                                        }}
                                    >
                                        ✕
                                    </button>
                                )}

                                {index === optionValues.length - 1 && (
                                    <>
                                        <button
                                            type="button"
                                            className="btn btn-sm btn-outline-primary d-flex align-items-center"
                                            style={{ borderRadius: "8px", padding: "6px 14px", fontWeight: 600, whiteSpace: "nowrap", gap: "4px" }}
                                            onClick={handleAddMoreInput}
                                        >
                                            <PlusOutlined /> Add More
                                        </button>
                                        <button
                                            type="button"
                                            className="btn btn-sm btn-primary d-flex align-items-center shadow-sm"
                                            style={{
                                                borderRadius: "8px",
                                                fontWeight: 600,
                                                padding: "6px 18px",
                                                whiteSpace: "nowrap",
                                                gap: "6px",
                                                backgroundColor: "#105293",
                                                borderColor: "#105293"
                                            }}
                                            onClick={handleDoneAttribute}
                                        >
                                            <CheckOutlined /> Done
                                        </button>
                                    </>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* Variants Table & Editor with + Add Custom Variant Row button */}
            <VairantTables
                productTypeNmae={productTypeNmae}
                id={id}
                setdataSet={setdataSet}
                dataSet={dataSet}
                datatype={variatType}
                submitFun={submitFun}
                hasVariants={hasVariants}
                variatType={variatType}
                productIdVariantsData={productIdVariantsData}
                handleOpen={handleOpen}
                handleClose={handleClose}
                tableData={tableData}
                settableData={settableData}
                product={product}
                upDateVariantsHandler={upDateVariantsHandler}
                manDatoryAttr={manDatoryAttr}
                getVariantsData={getVariantsData}
                deletHandlerWhileCreate={deletHandlerWhileCreate}
                handleAddManualVariantRow={handleAddManualVariantRow}
            />
        </div>
    );
}

